import { render, staticRenderFns } from "./coupon-dialog.vue?vue&type=template&id=564f6f47&scoped=true&"
import script from "./coupon-dialog.vue?vue&type=script&lang=js&"
export * from "./coupon-dialog.vue?vue&type=script&lang=js&"
import style0 from "./coupon-dialog.vue?vue&type=style&index=0&id=564f6f47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f6f47",
  null
  
)

export default component.exports